import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

export default function InputAuto(props) {
  const {
    name,
    label,
    value,
    variant,
    onChange,
    options = [],
    error = null,
    ...other
  } = props;
  const [val, setVal] = useState(null);

  const handleChange = (e, newVal) => {
    setVal(newVal);
    e.target.value = newVal ? newVal.id : "";
    e.target.name = name;
    onChange(e);
  };

  useEffect(() => {
    value && setVal(options.find((j) => j.id === value));
  }, [value, options]);

  return (
    <Autocomplete
      autoHighlight
      options={options}
      value={val || null}
      onChange={handleChange}
      classes={{ paper: "shadow-sm" }}
      {...other}
      renderInput={(params) => (
        <TextField
          variant={variant || "filled"}
          label={label}
          {...params}
          {...(error && { error: true, helperText: error })}
        />
      )}
    />
  );
}
